<template>
  <div class="agent-withdrawal-audit">
    <el-card shadow="never" class="filter-card">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item label="状态">
          <el-select v-model="status" clearable placeholder="全部" style="width: 140px;">
            <el-option label="待审核" :value="0" />
            <el-option label="成功" :value="1" />
            <el-option label="已拒绝" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card shadow="never">
      <el-table v-loading="loading" :data="records" border stripe>
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="adminId" label="团长ID" width="90" align="center" />
        <el-table-column prop="username" label="团长账号" width="140" show-overflow-tooltip />
        <el-table-column label="金额" width="110" align="center">
          <template slot-scope="scope">¥{{ formatYuan(scope.row.amount) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="warning" size="small">待审核</el-tag>
            <el-tag v-else-if="scope.row.status === 1" type="success" size="small">成功</el-tag>
            <el-tag v-else-if="scope.row.status === 2" type="danger" size="small">已拒绝</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="alipayOpenid" label="支付宝openid" min-width="180" show-overflow-tooltip />
        <el-table-column prop="transferNo" label="转账单号" min-width="160" show-overflow-tooltip />
        <el-table-column label="申请时间" width="170" align="center">
          <template slot-scope="scope">{{ formatDateTime(scope.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="180" align="center" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.status === 0">
              <el-button size="mini" type="success" @click="handleApprove(scope.row)">通过打款</el-button>
              <el-button size="mini" type="danger" @click="handleReject(scope.row)">拒绝</el-button>
            </template>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next"
        :current-page.sync="pagination.page"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @current-change="fetchRecords"
      />
    </el-card>
  </div>
</template>

<script>
import { get, put } from '@/utils/http'

export default {
  name: 'AgentWithdrawalAudit',
  data() {
    return {
      status: '',
      loading: false,
      records: [],
      pagination: { page: 1, pageSize: 10, total: 0 }
    }
  },
  mounted() {
    this.fetchRecords()
  },
  methods: {
    handleSearch() {
      this.pagination.page = 1
      this.fetchRecords()
    },
    handleReset() {
      this.status = ''
      this.pagination.page = 1
      this.fetchRecords()
    },
    async fetchRecords() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        if (this.status !== '' && this.status !== null) {
          params.status = this.status
        }
        const res = await get('/admin/agentWithdrawal/list', params)
        const data = res.data || {}
        this.records = data.records || []
        this.pagination.total = Number(data.total || 0)
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    handleApprove(row) {
      this.$confirm(
        `确认通过团长 ${row.username || row.adminId} 的提现 ¥${this.formatYuan(row.amount)} 并自动打款？`,
        '审核通过',
        { type: 'warning' }
      ).then(async () => {
        try {
          await put('/admin/agentWithdrawal', { id: row.id, status: 1 })
          this.$message.success('打款成功')
          this.fetchRecords()
        } catch (e) {
          this.$message.error(e.message || '打款失败')
        }
      }).catch(() => {})
    },
    handleReject(row) {
      this.$prompt('请输入拒绝原因（可选）', '审核拒绝', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: '拒绝原因'
      }).then(async ({ value }) => {
        try {
          await put('/admin/agentWithdrawal', {
            id: row.id,
            status: 2,
            auditRemark: value || '审核拒绝'
          })
          this.$message.success('已拒绝并退回余额')
          this.fetchRecords()
        } catch (e) {
          this.$message.error(e.message || '操作失败')
        }
      }).catch(() => {})
    },
    formatYuan(coins) {
      return (Number(coins || 0) / 1000).toFixed(2)
    },
    formatDateTime(v) {
      if (!v) return '-'
      return String(v).replace('T', ' ')
    }
  }
}
</script>

<style scoped>
.filter-card {
  margin-bottom: 16px;
}
.pager {
  margin-top: 16px;
  text-align: right;
}
</style>
